import { Dropdown } from 'primereact/dropdown';

import React from 'react';

import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';

import { typeIncidences } from '../../../../utils/utils';
import { MultiSelectComponent } from '../../../../components/MultiSelect/MultiSelectComponent';
import { Calendar } from 'primereact/calendar';
import { PropTypes } from 'prop-types';

export const FilterComponent = ({ service }) => {
	const {
		typeQuery,
		catalogData,
		filterData,
		handleSetFilterData,
		forceUpdateKey,
		handleStartAndEndDate,
		forceUpdateKeyTwo,
		clearFilters,
	} = service;

	const renderMultiSelect = (
		id,
		label,
		placeholder,
		optionLabel,
		value,
		options,
		onChange,
		otherPlaceHolder
	) => {
		return (
			<div className='flex w-full h-18 lg:h-[60px]  p-1 mt-[2px]'>
				<MultiSelectComponent
					id={id}
					value={value}
					optionLabel={optionLabel}
					options={options}
					onChange={onChange}
					placeholder={placeholder}
					title={label}
					otherPlaceHolder={otherPlaceHolder}
				/>
			</div>
		);
	};

	const renderDropComponent = (
		id,
		label,
		value,
		onChange,
		name,
		options,
		optionLabel,
		placeHolder
	) => {
		return (
			<div className='flex w-full h-18  flex-col pl-1 pr-1 lg:text-xs'>
				<div className='flex w-full h-full content-center items-center'>
					<label className=' font-bold lg:text-[12px] '>{label}</label>
				</div>
				<div className='flex w-full h-full content-center items-center justify-start flex-col'>
					<Dropdown
						value={value}
						onChange={onChange}
						name={id}
						id={id}
						options={options}
						optionLabel={optionLabel}
						className={'!w-full !h-5 !flex lg:!h-4 lg:!text-[10px] '}
						placeholder={placeHolder}
						disabled={options.length === 0}
					/>
				</div>
			</div>
		);
	};

	return (
		<div className='flex w-full h-full flex-col '>
			<div className='flex w-full h-full relative flex-col '>
				<div className='flex inset-0 flex-col overflow-auto absolute  gap-y-[1px]'>
					{renderDropComponent(
						'typeQuery',
						'Tipo de consulta',
						filterData.typeQuery,
						handleSetFilterData,
						'name',
						typeQuery,
						'name',
						'Seleccione un valor'
					)}

					<div className='flex w-full h-18  flex-col pl-1 pr-1 '>
						<div className='flex w-full h-full content-center items-center'>
							<label className=' font-bold text-sm lg:!text-xs'>
								{'Fecha Inicial'}
							</label>
						</div>
						<div className='flex w-full h-full content-center items-center justify-start flex-col'>
							<Calendar
								key={forceUpdateKey}
								id='startDate'
								readOnlyInput
								className={
									' !border-none !outline-none !p-0 !text-base !font-input-font-family !w-full lg:!text-[10px] lg:!h-4'
								}
								value={filterData.startDate}
								onChange={handleStartAndEndDate}
								//minDate={minDate !== null ? minDate : null}
								todayButtonClassName='hidden'
								dateFormat='dd-MM-yy'
								showIcon
								placeholder={'Seleccione fecha inicial'}
								locale='es'
								name='startDate'
							/>
						</div>
					</div>
					<div className='flex w-full h-18  flex-col p-1 '>
						<div className='flex w-full h-full content-center items-center'>
							<label className=' font-bold text-sm lg:!text-xs '>
								{'Fecha Final'}
							</label>
						</div>
						<div className='flex w-full h-full content-center items-center justify-start flex-col'>
							<Calendar
								key={forceUpdateKeyTwo}
								id='endDate'
								readOnlyInput
								className={
									' !border-none !outline-none !p-0 !text-base !font-input-font-family !w-full lg:!text-xs lg:!h-4'
								}
								value={filterData.endDate}
								onChange={handleStartAndEndDate}
								todayButtonClassName='hidden'
								dateFormat='dd-MM-yy'
								showIcon
								placeholder={'Seleccione fecha final'}
								locale='es'
								name='endDate'
							/>
						</div>
					</div>
					{renderDropComponent(
						'typePeriods',
						'Tipos de Periodos',
						filterData.typePeriods,
						handleSetFilterData,
						'name',
						catalogData.periodType,
						'name',
						catalogData.periodType.length > 0
							? 'Todos los tipos de periodos'
							: ' No se encontraron periodos'
					)}

					{renderMultiSelect(
						'workCenters',
						'Centros de trabajo',
						catalogData.workCenter.length > 0
							? 'Todos los centros de trabajo'
							: ' No se encontraron Centros de trabajo',
						'name',
						filterData.workCenters,
						catalogData.workCenter,
						handleSetFilterData,
						'Todos los centros de trabajo'
					)}

					{renderMultiSelect(
						'shifts',
						'Turnos',
						catalogData.shift.length > 0
							? 'Todos los turnos'
							: ' No se encontraron turnos',
						'name',
						filterData.shifts,
						catalogData.shift,
						handleSetFilterData,
						'Todos los turnos'
					)}

					{renderMultiSelect(
						'departments',

						'Departamentos',
						catalogData.department.length > 0
							? 'Todos los departamentos'
							: ' No se encontraron departamentos',
						'name',
						filterData.departments,
						catalogData.department,
						handleSetFilterData,

						'Todos los departamentos'
					)}

					{renderMultiSelect(
						'positions',
						'Puestos',
						catalogData.position.length > 0
							? 'Todos los puestos'
							: 'No se encontraron puestos',
						'name',
						filterData.positions,
						catalogData.position,
						handleSetFilterData,

						'Todos los puestos'
					)}

					{renderMultiSelect(
						'collaborators',
						'Colaboradores',
						catalogData.employee.length > 0
							? 'Todos los colaboradores'
							: 'No se encontraron colaboradores',
						'name',
						filterData.collaborators,
						catalogData.employee,
						handleSetFilterData,

						'Todos los colaboradores'
					)}

					{filterData.typeQuery?.code === 'I'
						? renderMultiSelect(
								'typeIncidents',

								'Tipos de incidencia',
								typeIncidences.length > 0
									? 'Todos los tipos de incidencias'
									: 'No se encontraron incidencias',
								'name',
								filterData.typeIncidents,
								typeIncidences,
								handleSetFilterData,

								'Todos los tipos de incidencias'
						  )
						: null}

					{filterData.typeQuery?.code === 'R' ? (
						<div className='flex w-full h-[60px]  flex-row pl-1 pr-1 items-center'>
							<Checkbox
								inputId='inactivesToo'
								name='inactivesToo'
								value='inactivesToo'
								//className='p-1'
								onChange={handleSetFilterData}
								checked={filterData.inactivesToo}></Checkbox>
							<label
								htmlFor='cb1'
								className='font-bold text-sm lg:!text-xs font-karla ml-1'>
								Incluir bajas
							</label>
						</div>
					) : null}
				</div>
			</div>
			<div className='flex w-full h-12 flex-row justify-between p-[4px] shadow-2xl border bg-white '>
				<Button
					label='Limpiar'
					className='!flex !w-28 !h-4 !bg-white !text-black !text-sm lg:!w-20 lg:!text-[10px]'
					aria-label='cancel'
					onClick={() => clearFilters()}
				/>
				<Button
					label='Consultar'
					className='!flex !w-28 !h-4 !text-sm lg:!w-20 lg:!text-[10px]  '
					aria-label='Submit'
					type='submit'
					onClick={() => service.getDataQueries()}
				/>
			</div>
		</div>
	);
};

FilterComponent.propTypes = {
	service: PropTypes.object,
};
